angular.module('tgaAdmin')
  .controller('DivisionsController', [
    '$scope', '$state', 'divisionService',
    function (
      $scope, $state, divisionService,
    ) {
      $scope.data = {
        alerts: [],
      };

      $scope.viewmodel = {};

      $scope.initialize = function () {
        $scope.loading = true;

        divisionService.getDivisions({ 'status[]': [0, 1] }, true).then((divisions) => {
          $scope.viewmodel.divisions = divisions;
          $scope.loading = false;
        }).catch((error) => {
          $scope.actions.createAlert(error);
        });
      };

      $scope.actions = {
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
